import type { TEventHandler, TEventHandlerParams, TEventName } from './types'

export class EventEmitter {
  private listeners = new Map<TEventName, Set<TEventHandler>>()

  on(eventName: TEventName, handler: TEventHandler) {
    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set())
    }

    const handlers = this.listeners.get(eventName)

    handlers?.add(handler)
  }

  off(eventName: TEventName, handler: TEventHandler) {
    const handlers = this.listeners.get(eventName)

    handlers?.delete(handler)

    if (handlers?.size === 0) {
      this.listeners.delete(eventName)
    }
  }

  emit(eventName: TEventName, ...params: TEventHandlerParams) {
    const handlers = this.listeners.get(eventName)

    if (!handlers) {
      return
    }

    for (const handler of handlers) {
      handler(...params)
    }
  }

  clear() {
    this.listeners.clear()
  }
}
